import React from "react";
import BarcodeReader from 'react-barcode-reader';

export const BarcodeScanner = () => {
    const [data, setData] = React.useState("Not Found");


    const handleScan = (data: string) => {
        setData(data)
    }
    const handleError = (err: any) => {
        console.error(err)
    }
    return (
        <>
            <BarcodeReader
                onError={handleError}
                onScan={handleScan}
            />
            <p>{data}</p>
        </>
    );
}